import className from 'classnames';
import './Spinner.scss';

const Spinner = ({ large = false }) => <span className={className('Spinner', { 'Spinner-large': large })} />;

const InlineSpinner = () => <span className={className('InlineSpinner')} />;

export { InlineSpinner, Spinner };
export default Spinner;
